import productService from '../../api/productService'


// initial state
const state = {
  operations: []
}

// getters
const getters = {
  // operations: state => state.operations
}

// actions
const actions = {
  fetchOperationsForSlot({ commit, state }, slots) {

    // if(state.operations.length > 0) {
    //
    // }

    return productService.listOperations()
        .then(operations => commit('SET_OPERATIONS', operations.filter(operation => slots.includes(operation.slot))));
  }
}

// mutations
const mutations = {
  SET_OPERATIONS(state, operations) {
    state.operations = operations
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/operations.js